import request from '@/utils/request'

import {
  serviceOptions,
  AccountService,
  UserService,
  OrganizationUnitService,
  // AuditLogService,
  CmsContentService,
  CmsCategoryService,
  CmsAnchorService,
  SwiperService,
  CmsFriendLinkService,

  SessionService,
  RoleService,
  AuditFlowService,
  AuditNodePreDefineService,
  DepartmentService,
  AttachmentService,
  PermissionDefinitionService,

  NotifyTemplateService,
  DataDictionaryService,

  PartnerInviteService,

  EnumService,
  AlbumService,
  CapitalIncomeRecordFromOtherService,
  CapitalIncomeRecordFromDonationService,
  CapitalExpenseRecordAppserviceService,
  InternalMonthlyPlanService,
  InternalMonthlySummarizeService,
  InternalPersonalYearEndSummaryService,
  ExternalProjectIntentionService,
  ExternalMonthlyPlanService,
  ExternalMonthlySummarizeService,
  ProjectInviteService,
  ProjectService,
  ProjectSeriesService,
  ExternalDueDiligenceRecordService,
  ExternalProjectProcessMonitoringService,
  ExternalProjectProgressReportService,
  ExternalProjectSummaryReportService,
  ExternalProjectService,
  ExternalProjectCloseReportService,
  NotifyRecordService,
  ProvinceService,
  CityService,
  AreaService,
  TownService,
  CustomFormService,
  InternalProjectSummaryReportsService,
  InternalProjectService,
  PartnerCapitalApplyService,
  BeneficiaryService,
  ProjectBeneficiaryMappingService,
  BeneficiaryServiceRecordServiceService,
  BankReconciliationService,
  InternalProjectPhaseService,
  ExternalProjectPhaseService,
  InternalProjectReportService,
  ExternalProjectReportService,
  ExternalProjectChangeApplyService,
  FundService,
  FundApplyService,
  MessageService,
  FundModifyApplyService,
  FundUserService,
  AuditFlowProxyService,
  FundProjectService,
  FundProjectApplyService,
  FundProjectYearSummaryService,
  FundProjectModifyApplyService,
  FundProjectProgressService,
  FundDonationOrderService,
  FundNonCashDonationService,
  FundAppropriateApplyService,
  FundProjectDonationRecordService,
  FundAccountService,
  FundAppropriateRecordService,
  FundIncomeRecordService,
  FundManageFeeRecordService,
  FundDonationMonthlyConfigService,
  ActivityService,
  ActivityApplyService,
  ActivitySignInRecordService,
  VolunteerService,
  VolunteerServiceHistoryService,
  UserTaskService,
  JobService,
  FeedbackService,
  FeedbackReplyService,
  ElectronicInvoiceService,
  ApplicationPaymentService,
  DonatedAmountConfigService,
  DashbordService,
  TenantBankAccountService,
  MerchantService,
  MerchantBankAccountService,
    CycleDonateConfigService,
  ScopeDataSourceService,
  TokenAuthService,
    BankTypeService,
  BankNameService,
  CollectWaterService
} from './appService'

import {Attachment} from './attachment';
import FeedbackReplyList from "@/views/feedback/replyList.vue";
import CollectWaterList from "@/views/financeNew/collectWater/list.vue";


serviceOptions.axios = request;

//const basrUrl = process.env.VUE_APP_BASE_API;

const tokenAuth = TokenAuthService;
const auditFlow = AuditFlowProxyService;
const auditNodePreDefine = AuditNodePreDefineService;
const account = AccountService;
const album = AlbumService;
const cmsContent = CmsContentService;
const cmsCategory = CmsCategoryService;
const cmsAnchor = CmsAnchorService;
const cmsFriendLink = CmsFriendLinkService;
const swiper = SwiperService;
const department = DepartmentService;
const organizationUnit = OrganizationUnitService;
const role = RoleService;
const session = SessionService;
const user = UserService;
const attachment = Attachment;
const attachmentService = AttachmentService;
const permissionDefinition = PermissionDefinitionService;

const partnerInvite = PartnerInviteService;
const notifyTemplate = NotifyTemplateService;
const dataDictionary = DataDictionaryService;
const capitalIncomeRecordFromOther = CapitalIncomeRecordFromOtherService;
const capitalIncomeRecordFromDonation = CapitalIncomeRecordFromDonationService;
const capitalExpenseRecord = CapitalExpenseRecordAppserviceService;
const internalMonthlyPlan = InternalMonthlyPlanService;
const internalMonthlySummarize = InternalMonthlySummarizeService;
const internalPersonalYearEndSummary = InternalPersonalYearEndSummaryService;
const enumService = EnumService;
const externalProjectIntention = ExternalProjectIntentionService;
const externalMonthlyPlanService = ExternalMonthlyPlanService;
const externalMonthlySummarize = ExternalMonthlySummarizeService;
const projectInvite = ProjectInviteService;
const projectSeries = ProjectSeriesService;
const project = ProjectService;
const externalDueDiligenceRecord = ExternalDueDiligenceRecordService;
const externalProjectProcessMonitoringService = ExternalProjectProcessMonitoringService;
const externalProjectProcessReport = ExternalProjectProgressReportService;
const externalProjectSummaryReport = ExternalProjectSummaryReportService;
const notifyRecord = NotifyRecordService;
//
const province = ProvinceService;
const city = CityService;
const area = AreaService;
const town = TownService;
const externalProject = ExternalProjectService;
const externalProjectCloseReport = ExternalProjectCloseReportService;

const customFormService = CustomFormService;
const internalProjectSummaryReports = InternalProjectSummaryReportsService;
const internalProject = InternalProjectService;
const partnerCapitalApply = PartnerCapitalApplyService;
const beneficiary = BeneficiaryService;
const projectBeneficiaryMapping = ProjectBeneficiaryMappingService;
const beneficiaryServiceRecord = BeneficiaryServiceRecordServiceService;
const bankReconciliation = BankReconciliationService;
const guid = '00000000-0000-0000-0000-000000000000';

const internalProjectPhase = InternalProjectPhaseService;
const externalProjectPhase = ExternalProjectPhaseService;
const internalProjectReport = InternalProjectReportService;
const externalProjectReport = ExternalProjectReportService;
const externalProjectChangeApply = ExternalProjectChangeApplyService;

const fund = FundService;
const fundApply = FundApplyService;
const message = MessageService;
const fundModifyApply = FundModifyApplyService;
const fundUser = FundUserService;
const fundAccount = FundAccountService;
const fundAppropriateRecord = FundAppropriateRecordService;
const fundIncomeRecord = FundIncomeRecordService;

const fundProject = FundProjectService;
const fundProjectApply = FundProjectApplyService;
const fundProjectModifyApply = FundProjectModifyApplyService;
const fundProjectYearSummaryService = FundProjectYearSummaryService;
const fundProjectProgress = FundProjectProgressService;
const fundDonationOrder = FundDonationOrderService;
const fundProjectDonationRecord = FundProjectDonationRecordService;
const fundNonCashDonation = FundNonCashDonationService;
const fundAppropriateApply = FundAppropriateApplyService;
const fundManageFeeRecord = FundManageFeeRecordService;
const fundDonationMonthly = FundDonationMonthlyConfigService;
const cycleDonateConfig = CycleDonateConfigService;

//activity
const activity = ActivityService;
const activityApply = ActivityApplyService;
const activitySignInRecord = ActivitySignInRecordService;

//volunteer
const volunteer = VolunteerService;
const volunteerServiceHistory = VolunteerServiceHistoryService;

const userTask = UserTaskService;
const job = JobService;
const feedback = FeedbackService;
const feedbackReply = FeedbackReplyService;
const electronicInvoice = ElectronicInvoiceService;
const applicationPayment = ApplicationPaymentService;
const donatedAmountConfig = DonatedAmountConfigService;

const dashboard = DashbordService;
const tenantBankAccount = TenantBankAccountService
const merchant = MerchantService
const merchantBankAccount = MerchantBankAccountService
const dataPermissionScopeProvider = ScopeDataSourceService
const bankType = BankTypeService;
const bankName = BankNameService;
const collectWater = CollectWaterService;

export default {
  tokenAuth,
  auditFlow,
  album,
  auditNodePreDefine,
  account,
  cmsContent, cmsCategory, cmsAnchor, cmsFriendLink, swiper,
  organizationUnit, department,
  role,
  session,
  user,
  attachment,
  attachmentService,
  permissionDefinition,
  notifyTemplate,
  partnerInvite,
  enumService,
  guid,
  dataDictionary,
  capitalIncomeRecordFromOther,
  capitalIncomeRecordFromDonation,
  capitalExpenseRecord,
  internalMonthlyPlan,
  internalMonthlySummarize,
  internalPersonalYearEndSummary,
  externalProjectIntention,
  projectInvite,
  projectSeries,
  project,
  externalDueDiligenceRecord,
  externalProjectProcessMonitoringService,
  externalProjectProcessReport,
  externalMonthlyPlanService,
  externalMonthlySummarize,
  notifyRecord,
  externalProjectSummaryReport,
  province, city, area, town,
  externalProject,
  externalProjectCloseReport,
  internalProjectSummaryReports,
  internalProject,
  customFormService,
  partnerCapitalApply,
  beneficiary,
  projectBeneficiaryMapping,
  beneficiaryServiceRecord,
  bankReconciliation,
  internalProjectPhase,
  externalProjectPhase,
  internalProjectReport,
  externalProjectReport,
  externalProjectChangeApply,
  fund,
  fundApply,
  message,
  fundModifyApply,
  fundUser,
  fundProject,
  fundProjectApply,
  fundProjectModifyApply,
  fundProjectYearSummaryService,
  fundProjectProgress,
  fundDonationOrder,
  fundProjectDonationRecord,
  fundNonCashDonation,
  fundAppropriateApply,
  fundAccount,
  fundIncomeRecord,
  fundAppropriateRecord,
  fundManageFeeRecord,
  fundDonationMonthly,
  cycleDonateConfig,
  //activity
  activity,
  activityApply,
  activitySignInRecord,

  //volunteer
  volunteer,
  volunteerServiceHistory,

  userTask,
  job,
  feedback,
  feedbackReply,
  electronicInvoice,
  applicationPayment,
  donatedAmountConfig,

  dashboard,
  tenantBankAccount,
  merchant,
  merchantBankAccount,
  bankType,
  bankName,
  dataPermissionScopeProvider,
  collectWater
}
